(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyPaymentLogDeleteController', CompanyPaymentLogDeleteController);

    CompanyPaymentLogDeleteController.$inject = ['$uibModalInstance', 'entity', 'CompanyPaymentLog'];

    function CompanyPaymentLogDeleteController($uibModalInstance, entity, CompanyPaymentLog) {
        var vm = this;

        vm.companyPaymentLog = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            CompanyPaymentLog.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
